<template>
    <tbody>
        <tr
            v-for="(item, index) in items"
            :key="index"
            :class="`${isStatusClosed(item) ? 'disabled' : ''}`"
        >
            <!-- === === MONUFACTURER=== === -->
            <td class="truncate">
                {{ item.manufacturer }}
            </td>
            <!-- === === MODEL === === -->
            <td class="truncate">{{ item.model }}</td>
            <!-- === === DEVICE TYPE === === -->
            <td class="truncate">
                {{ item.deviceType }}
            </td>
            <!-- === === SERVICE PRICE === === -->
            <td class="truncate">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{
                            $get(item.servicePrice, 'name', '')
                        }}</span>
                    </template>
                    <span>{{ createPriceText(item.servicePrice) }}</span>
                </v-tooltip>
            </td>
            <!-- === === STATUS === === -->
            <td>
                <v-chip
                    :color="$get(item, 'status.color.background', '#555555')"
                    :style="`color: ${$get(
                        item,
                        'status.color.font',
                        '#FFFFFF'
                    )}`"
                    dark
                    label
                    small
                    >{{ $get(item, 'status.name', $t('users:empty')) }}</v-chip
                >
            </td>
            <td class="d-flex align-center justify-end">
                <v-icon small v-if="hasFile(item.folders)"
                    >mdi-paperclip</v-icon
                >
                <v-menu bottom v-if="remove()">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                            <v-icon color="iconGray" small
                                >mdi-dots-vertical</v-icon
                            >
                        </v-btn>
                    </template>
                    <v-list dense>
                        <!-- === === REMOVE === === -->
                        <v-list-item @click="openConfirmModal(item._id)">
                            <v-list-item-icon class="mr-0">
                                <v-icon color="red" small>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Usuń</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn small router :to="`/models/${item._id}`" icon>
                    <v-icon color="secondary" small
                        >mdi-arrow-right-thick</v-icon
                    >
                </v-btn>
            </td>
        </tr>
        <ConfirmModal
            :openConfirm="openConfirm"
            @close-confirm="closeConfirmModal"
        >
            <div slot="main"><ConfirmContent /></div>
            <div slot="buttons">
                <div class="d-flex justify-center">
                    <v-btn
                        color="rgb(117, 117, 117)"
                        width="110"
                        height="40"
                        @click="closeConfirmModal()"
                        class="white--text mx-2"
                        >{{ $t('global:cancel') }}</v-btn
                    >
                    <v-btn
                        width="110"
                        height="40"
                        color="#445d75"
                        class="white--text mx-2"
                        @click="deleteItem()"
                        >{{ $t('global:remove') }}</v-btn
                    >
                </div>
            </div>
        </ConfirmModal>
    </tbody>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmContent from '../../Departments/ConfirmModal/ConfirmContent.vue'
export default {
    props: ['items'],
    data: () => ({
        openConfirm: false,
        removeItemID: '',
    }),
    components: {
        ConfirmContent,
    },
    computed: {
        ...mapGetters(['getProfileDetails']),
    },
    methods: {
        ...mapActions(['deleteModel']),
        openConfirmModal(id) {
            this.removeItemID = id
            this.openConfirm = true
        },
        closeConfirmModal() {
            this.openConfirm = false
        },
        async deleteItem() {
            let result = await this.deleteModel({ id: this.removeItemID })
            if (result) this.openConfirm = false
        },
        remove() {
            return this.checkPermissions('DELETE')
        },
        createPriceText(prices) {

                let str = ''
                str += `${this.$t('service:survey')}: ${Number(
                    this.$get(prices, 'survey.price', 0)
                ).toFixed(2)} PLN / `
                str += `${this.$t('service:repair')}: ${Number(
                    this.$get(prices, 'repair.price', 0)
                ).toFixed(2)} PLN / `
                str += `${this.$t('service:installation')}: ${Number(
                    this.$get(prices, 'installation.price', 0)
                ).toFixed(2)} PLN / `
                str += `${this.$t('service:diagnostics')}: ${Number(
                    this.$get(prices, 'diagnostics.price', 0)
                ).toFixed(2)} PLN / `
                str += `${this.$t('service:itService')}: ${Number(
                    this.$get(prices, 'itService.price', 0)
                ).toFixed(2)} PLN / `
                str += `${this.$t('service:remote')}: ${Number(
                    this.$get(prices, 'remote.price', 0)
                ).toFixed(2)} PLN `
                return str
          
        }
    },
}
</script>
